module.exports = __webpack_public_path__ + "static/media/icon-user-default.84b9e145.svg";